// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__5V+c4","toggleTransition":"button_toggleTransition__vsJ76"};